import { useClubData } from '../lib/club-data.context';

/**
 * Hook to fetch team players for the user's club
 * Uses the ClubDataContext to access centralized team data
 */
export const useTeam = () => {
  const { teamPlayers, isLoading, error } = useClubData();
  
  return { 
    data: { players: teamPlayers },
    isLoading,
    error
  };
};